import { render, staticRenderFns } from "./lastyearachievementrate.vue?vue&type=template&id=72a31dc7&scoped=true&"
import script from "./lastyearachievementrate.vue?vue&type=script&lang=ts&"
export * from "./lastyearachievementrate.vue?vue&type=script&lang=ts&"
import style0 from "./lastyearachievementrate.vue?vue&type=style&index=0&id=72a31dc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a31dc7",
  null
  
)

export default component.exports